module.exports = __webpack_public_path__ + "static/media/Iconfield08.8b3cef48.svg";